// extracted by mini-css-extract-plugin
export default {"container":"FilterSection-module__container--Ds2H5","filterWrapper":"FilterSection-module__filterWrapper--y5FvC","searchSelect":"FilterSection-module__searchSelect--_n2cK"};